import PropTypes from "prop-types"
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Button,} from "reactstrap";
import Moment from "moment";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";


import { setFilterDomains, setFilterVersionStatus,  toogleDataCheck, setFilterDimensions, setFilterExtendedStatsDomains, setFilterIntervallo, setFilterDataDa, setFilterDataA, setFilterMese, setFilterDataProducts, setFullTextSearch,setIsCompleteSearch, setFilterOwner}  from "../../store/app/DataQualityStatus/DataQualitySlice";
import { setFilterProductTypes, setFilterStatusCount } from "../../store/app/DataRollCall/DataRollCallSlice";
import { setFilterProcessType } from "../../store/app/ProcessRuns/ProcessRunsSlice";


const FilterSubmit = ( props ) => {
  const dispatch = useDispatch();

	let [searchParams, setSearchParams] = useSearchParams();
	const intervallo = useSelector( (state) => state.dataQualityReducer.filterIntervallo);
	const fromDate = useSelector( (state) => state.dataQualityReducer.filterDataDa );
	const toDate = useSelector( (state) => state.dataQualityReducer.filterDataA );
	const domains = useSelector( (state) => state.dataQualityReducer.filterDomains || []);
	const versionStatus = useSelector( (state) => state.dataQualityReducer.filterVersionStatus );
	const ProcessTypes = useSelector( (state) => state.processRunsReducer.filterProcessTypes );
	const rollCallStatusDomains = useSelector( (state) => state.dataRollCallReducer.filterStatusCountDomains );
	const productTypes = useSelector( (state) => state.dataRollCallReducer.filterProductTypes );
	const extendedStatsDomains = useSelector( (state) => state.dataQualityReducer.filterExtendedStatsDomains)
	const dimensions = useSelector( (state) => state.dataQualityReducer.filterDimensions)
	const mese = useSelector( (state) => state.dataQualityReducer.filterMese)
	const dataProducts = useSelector( (state) => state.dataQualityReducer.filterDataProducts)
	const dataCheck  = useSelector( (state) => state.dataQualityReducer.dataCheck)
	const owner = useSelector( (state) => state.dataQualityReducer.filterOwner)
	const fullTextSearch = useSelector( (state) => state.dataQualityReducer.fullTextSearch)
	const isCompleteSearch = useSelector( (state) => state.dataQualityReducer.isCompleteSearch)

	const {text, onClick, ...restProps } = props;


	const handleClick = ((event) => {
	
	
		if (intervallo == -1 || intervallo == -2 ){
			searchParams.set('fromDate', Moment (fromDate).format ('YYYY-MM-DD HH:mm:ss'))
			searchParams.set('toDate', Moment (toDate).format ('YYYY-MM-DD HH:mm:ss'))
		}else{
			searchParams.delete('fromDate')
			searchParams.delete('toDate')
		}
		domains?.length > 0 ? searchParams.set('domains', JSON.stringify (domains)) : searchParams.delete('domains')
		versionStatus?.length > 0 ? searchParams.set('status', JSON.stringify (versionStatus)) :searchParams.delete('status')
		ProcessTypes?.length > 0 ?  searchParams.set('process', JSON.stringify (ProcessTypes)) : searchParams.delete('process')
		rollCallStatusDomains?.length > 0 ? searchParams.set('rollcallstatus', JSON.stringify (rollCallStatusDomains)) : searchParams.delete('rollcallstatus')
		productTypes?.length > 0 ? searchParams.set('producttypes', JSON.stringify (productTypes)) : searchParams.delete('producttypes')
		extendedStatsDomains?.length > 0 ? searchParams.set('extendedStatsDomains', JSON.stringify (extendedStatsDomains)) : searchParams.delete('extendedStatsDomains')
		dimensions?.length > 0 ? searchParams.set('dimensions', JSON.stringify (dimensions)) : searchParams.delete('dimensions')
		dataProducts?.length > 0 ? searchParams.set('dataproducts', JSON.stringify (dataProducts)) : searchParams.delete('dataproducts')
		owner == "" > 0 ? searchParams.delete('owner') : searchParams.set('owner', JSON.stringify (owner))
		fullTextSearch == "" ? searchParams.delete('fulltext') : searchParams.set('fulltext', fullTextSearch)
		isCompleteSearch ? searchParams.set('isCompleteSearch', true) : searchParams.delete('isCompleteSearch')
		
		mese == 0 ? searchParams.delete('mese') : searchParams.set('mese', mese )



		searchParams.set('interval', intervallo)
		
		

		// console.log ('handleClick::params', searchParams.toString())
		//dispatch(setRefreshCount (refreshCount + 1))
		dispatch(toogleDataCheck(false))
		// dispatch(setRefreshData(true))
		setSearchParams(searchParams)
	})

	const handleReset = () => {

		const interval = searchParams.get('interval') ? searchParams.get('interval') : 24

		dispatch(setFilterIntervallo(interval))
		dispatch(setFilterDataDa(searchParams.get('fromDate') ? Moment (searchParams.get('fromDate')).toDate() : Moment().subtract(interval, 'hours').format ('YYYY-MM-DD HH:mm:ss')))
		dispatch(setFilterDataA(searchParams.get('toDate') ? Moment (searchParams.get('toDate')).toDate() : Moment().format ('YYYY-MM-DD HH:mm:ss')))
		dispatch(setFilterMese(searchParams.get('mese') ? JSON.parse(searchParams.get('mese')) : 0))

		dispatch(setFilterDomains(searchParams.get('domains') ? JSON.parse(searchParams.get('domains')) : []))
		dispatch(setFilterExtendedStatsDomains(searchParams.get('extendedStatsDomains') ? JSON.parse(searchParams.get('extendedStatsDomains')) : []))	
		dispatch(setFilterVersionStatus(searchParams.get('status') ? JSON.parse(searchParams.get('status')) : []))
		dispatch(setFilterDimensions(searchParams.get('dimensions') ? JSON.parse(searchParams.get('dimensions')) : []))
		dispatch(setFilterDataProducts(searchParams.get('dataproducts') ? JSON.parse(searchParams.get('dataproducts')) : []))

		dispatch(setFilterProcessType(searchParams.get('process') ? JSON.parse(searchParams.get('process')) : []))

		dispatch(setFilterStatusCount(searchParams.get('rollcallstatus') ? JSON.parse(searchParams.get('rollcallstatus')) : []))	
		dispatch(setFilterProductTypes(searchParams.get('producttypes') ? JSON.parse(searchParams.get('producttypes')) : []))
		
		dispatch(setFilterOwner(searchParams.get('owner') ? JSON.parse(searchParams.get('owner')) : ""))

		dispatch(setFullTextSearch(searchParams.get('fulltext') ? searchParams.get('fulltext') : ""))
		dispatch(setIsCompleteSearch(searchParams.get("isCompleteSearch") === "true"))

		dispatch(toogleDataCheck(false));
	}

	return (
    <div className="d-flex gap-2 align-items-center">
      <Button disabled={!dataCheck} {...restProps} onClick={handleClick} title="Apply selected filter to update data">
        {text || "Filter"}
      </Button>

      <Button
        outline
        color="primary"
        title="Reset filters to return to the state consistent with the displayed data"
        onClick={handleReset}
        disabled={!dataCheck}
      >
        <FeatherIcon icon="rotate-ccw" size={16} />
      </Button>
    </div>
  );
  
}

FilterSubmit.propTypes = {
  onClick: PropTypes.any,
  text: PropTypes.string
}



export default FilterSubmit
